import { getToken, setToken } from '@/commons/utils/cookies';
import wxUtils, { EnvType } from '@/commons/utils/wx';
import store from '@/store';
import { getModule, Module, Mutation, VuexModule } from 'vuex-module-decorators';

export interface IAppState {
    env: EnvType;
    appLoading: boolean;
}

@Module({ dynamic: true, store, name: 'app' })
class App extends VuexModule implements IAppState {
    /**
     * 全局loading
     */
    public appLoading: boolean = false;
    /**
     * 当前浏览器的微信环境
     */
    public env = wxUtils.getEnv();
    /**
     * TOKEN
     */
    public token = getToken() || '';

    /**
     * 学生列表
     */
    public stuList: any[] | null = null;

    @Mutation
    public SET_TOKEN(token: string) {
        this.token = token;
        setToken(this.token);
    }

    @Mutation
    public SET_STU_LIST(list: any[]) {
        this.stuList = list;
    }

    @Mutation
    public SET_LOADING(loading: boolean) {
        this.appLoading = loading;
    }
}

export const AppModule = getModule(App);
